import {
  Component,
  ContentChild,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import { HorizontalAlignment } from '@freelancer/ui/grid';
import {
  HeadingColor,
  HeadingType,
  HeadingWeight,
} from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';

export enum SectionHeroContentWidth {
  SMALL = '6',
  MEDIUM = '8',
  LARGE = '10',
}

export enum SectionHeroHeight {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  RESPONSIVE = 'responsive',
}

export enum SectionHeroAlignment {
  LEFT = 'left',
  CENTER = 'center',
}

export enum SectionHeroBackgroundColor {
  DARK = 'dark',
  LIGHT = 'light',
}

@Component({
  selector: 'fl-section-hero-detail-text',
  template: `
    <ng-content></ng-content>
  `,
})
export class SectionHeroDetailTextComponent {}

@Component({
  selector: 'fl-section-hero-title',
  template: `
    <ng-content></ng-content>
  `,
})
export class SectionHeroTitleComponent {}
@Component({
  selector: 'fl-section-hero-description',
  template: `
    <ng-content></ng-content>
  `,
})
export class SectionHeroDescriptionComponent {}

@Component({
  selector: 'fl-section-hero',
  template: `
    <fl-container>
      <fl-grid
        [hAlign]="
          alignment == SectionHeroAlignment.CENTER &&
          HorizontalAlignment.HORIZONTAL_CENTER
        "
      >
        <fl-col [col]="12" [colDesktopSmall]="contentWidth">
          <fl-bit
            *ngIf="sectionHeroDetailText"
            [flMarginBottom]="Margin.XSMALL"
          >
            <ng-content select="fl-section-hero-detail-text"></ng-content>
          </fl-bit>
          <fl-heading
            [color]="
              backgroundColor === SectionHeroBackgroundColor.DARK
                ? HeadingColor.LIGHT
                : HeadingColor.DARK
            "
            [headingType]="HeadingType.H1"
            [flMarginBottom]="Margin.LARGE"
            [size]="TextSize.XXXLARGE"
          >
            <ng-content select="fl-section-hero-title"></ng-content>
          </fl-heading>
          <fl-heading
            *ngIf="sectionHeroDescription"
            [color]="
              backgroundColor === SectionHeroBackgroundColor.DARK
                ? HeadingColor.LIGHT
                : HeadingColor.DARK
            "
            [headingType]="HeadingType.H2"
            [flMarginBottom]="Margin.LARGE"
            [size]="TextSize.LARGE"
            [weight]="HeadingWeight.NORMAL"
          >
            <ng-content select="fl-section-hero-description"></ng-content>
          </fl-heading>
          <ng-content></ng-content>
        </fl-col>
      </fl-grid>
    </fl-container>
  `,
  styleUrls: ['./section-hero.component.scss'],
})
export class SectionHeroComponent {
  HeadingColor = HeadingColor;
  TextSize = TextSize;
  HeadingType = HeadingType;
  HeadingWeight = HeadingWeight;
  Margin = Margin;
  SectionHeroBackgroundColor = SectionHeroBackgroundColor;

  @HostBinding('attr.data-alignment')
  @Input()
  alignment: SectionHeroAlignment = SectionHeroAlignment.LEFT;

  @HostBinding('attr.data-height')
  @Input()
  height: SectionHeroHeight = SectionHeroHeight.MEDIUM;

  @Input() contentWidth: SectionHeroContentWidth =
    SectionHeroContentWidth.SMALL;

  @HostBinding('attr.data-background-color')
  @Input()
  backgroundColor = SectionHeroBackgroundColor.DARK;

  @ContentChild(SectionHeroDescriptionComponent)
  sectionHeroDescription: SectionHeroDescriptionComponent;
  @ContentChild(SectionHeroDetailTextComponent)
  sectionHeroDetailText: SectionHeroDetailTextComponent;

  SectionHeroAlignment = SectionHeroAlignment;
  HorizontalAlignment = HorizontalAlignment;

  constructor(@Inject(UI_CONFIG) public uiConfig: UiConfig) {}
}
